// Store Navbar icons
const state = {
    navbar: {
        'show': {
            notification: false,
            people: false,
            profile: false
        }
    }
};

const mutations = {
    'SHOW_NOTIFICATION' (state) {
        state.navbar.show.notification = true;
    },
    'HIDE_NOTIFICATION' (state){
        state.navbar.show.notification = false;
    },
    'SHOW_PROFILE' (state) {
        state.navbar.show.profile = true;
    },
    'HIDE_PROFILE' (state){
        state.navbar.show.profile = false;
    },
    'SHOW_PEOPLE' (state) {
        state.navbar.show.people = true;
    },
    'HIDE_PEOPLE' (state){
        state.navbar.show.people = false;
    }
};

const actions = {
    showNotification: ({commit}) => {
        commit('SHOW_NOTIFICATION');
    },
    hideNotification: ({commit}) => {
        commit('HIDE_NOTIFICATION');
    },
    showProfile: ({commit}) => {
        commit('SHOW_PROFILE');
    },
    hideProfile: ({commit}) => {
        commit('HIDE_PROFILE');
    },
    showPeople: ({commit}) => {
        commit('SHOW_PEOPLE');
    },
    hidePeople: ({commit}) => {
        commit('HIDE_PEOPLE');
    }
};

const getters = {
    navbar: state => {
        return state.navbar;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/navbar.js